import { listCategories } from '@/modules/inventory/services/categoryRepository';
import { listItems } from '@/modules/inventory/services/itemRepository';
import type { InventoryStatus } from '@/modules/inventory/types';

export type InventoryDashboardStats = {
  totalItems: number;
  available: number;
  inMaintenance: number;
  reserved: number;
  activeCategories: number;
};

function countByStatus(
  items: Awaited<ReturnType<typeof listItems>>,
  status: InventoryStatus,
): number {
  return items.filter((i) => i.status === status).length;
}

export async function fetchInventoryDashboardStats(): Promise<InventoryDashboardStats> {
  const [items, categories] = await Promise.all([
    listItems(),
    listCategories(),
  ]);

  return {
    totalItems: items.filter((i) => i.status !== 'inactive').length,
    available: countByStatus(items, 'available'),
    inMaintenance:
      countByStatus(items, 'maintenance') + countByStatus(items, 'repair'),
    reserved: countByStatus(items, 'reserved'),
    activeCategories: categories.filter((c) => c.active).length,
  };
}
